<section class="container-fluid px-0"
         style="background: url(https://img.freepik.com/free-photo/cloud-system-tablet-background-smart-technology-remixed-media_53876-124705.jpg?t=st=1741175695~exp=1741179295~hmac=158e7b66063168fa8f9ec8530d17d85cff2d66856e507d73021b73a1a35c3415&w=1060); background-position: right; background-size: cover">
    <div class=" mt-0 hero w-100 d-flex align-items-center">
        <div class="container">
            <div class="row  w-100">
                <div class=" col-md-6 align-self-center hero-text">
                    <h1 class="text-white w-100 fw-bold">Empower Your Digital Transformation with Public Cloud Computing & Delivery Solutions</h1>
                    <p class="text-white">
                        Get ready to take your digital infrastructure to the next level with Volmint’s Public Cloud Computing services. From secure database management to smooth migration, integration, and delivery, we ensure the best performance, security, and reliability like never before.
                    </p>
                    <div class="hero-buttons">
                        <button class="btn-primary" (click)="openModal()">Get Started </button>
                    </div>
                    <ng-template #contactFormModal>
                        <app-contact-form [isModalOpen]="isModalOpen"
                                          (closeModal)="closeModal()"></app-contact-form>
                    </ng-template>
                    <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                        <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                    </div>
                </div>
                <div class="col-md-6 text-md-end">
                    <img src="assets/img/landing-new/cloud-db-cdn/serve.png" alt="">
                </div>
            </div>
        </div>


    </div>

</section>
<div class="container-fluid bg-light p-5">
    <div class="container  shadow-sm ">
        <div class="row bg-white py-0 shadow " style="top :-50px" >
            <div class="col-md-6 ps-md-5 py-md-5 py-4">
                <h2 class=" fs-1 fw-bolder ">About Volmint’s - Your Trusted Partner for Scalable Cloud Solutions
                </h2>
                <p>
                    Public cloud computing enhances IT performance, speed, and scalability while supporting modern application development. However, each cloud varies, and without proper guidance, businesses may face inefficiencies, wasted resources, and high costs. Volmint Technologies is a well-known Public Cloud Computing provider offering advanced cloud and delivery solutions to meet your unique business challenges.

                </p>
                <p>
                    As the leading experts in database management services, we ensure unmatched scalability, robust security, and performance optimizations for all sizes of organizations. From utilizing the most reliable public cloud technologies to delivering efficient content delivery network solutions, we enable your organization to thrive in today’s fast-paced digital environment.

                </p>
                <p>
                    Our well-equipped services encompass managed cloud services, databases in cloud computing, and content delivery network services, leading businesses to reduce costs, improve efficiency, and achieve operational excellence. Whether you're transitioning to the cloud or enhancing your current setup, Volmint delivers results that drive success.
                </p>
            </div>
            <div class="col-md-6 m-0 p-0 text-right ">
                <img src="https://img.freepik.com/premium-photo/waist-up-portrait-smiling-african-american-man-standing-by-server-cabinet-while-working-with-supercomputer-data-center-holding-tablet-copy-space_236854-29016.jpg"
                     class="w-100 h-100"
                     alt="Image">
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-50px" >
    <div class=" container py-5">

        <div class="row gy-3 pb-5 align-items-center">
            <div class="col-md-6 px-md-5">
                <h2 class=" fs-1  fw-bold justify-text">Why Choose Volmint’s Public Cloud & Content Delivery Network Services?</h2>
                <img src="https://img.freepik.com/premium-photo/person-standing-server-room-looking-rows-servers-with-digital-network-overlay_36682-215438.jpg?w=360" alt="" class="w-100"/>
            </div>

            <div class="col-md-6  px-md-5">
                <ng-container  *ngFor="let item of whyChoose1; let i = index">

                    <div class="dashed-border  mt-3 d-flex">
                        <div>
                            <div class=" align-items-center p-2  border-left    fw-bold ">
                                <i [ngClass]="item.icon" class="fs-4 blue-color"></i></div>
                        </div>

                        <div class="px-3 pb-3">
                            <h3 class="fs-6 fw-bold">{{ item.header }}</h3>
                            <p class=" justify-text">{{
                                    item.text
                                }}</p>
                        </div>

                    </div>
                </ng-container>

            </div>
        </div>
    </div>
</div>

<div class="container-fluid ">
    <div class="container py-5">
        <h2 class="   fw-bold justify-text"><span class="blue-color"> Our Services  -</span> Advanced Cloud and Delivery Solutions for Every Business Need</h2>
        <p>Volmint Technologies provides a full spectrum of services, from public cloud computing to content delivery network solutions and database management services, tailored to empower your business.
        </p>

        <div class="my-5 position-relative">
            <div class="text-center w-100 border d-flex justify-content-between mb-4">
                <button class="btn btn-primary border-0 rounded-0"
                        (click)="prevSlide()">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
                <button class="btn btn-primary border-0 fw-bold  rounded-0 w-100 px-4 py-2">
                    {{ tabs[selectedIndex].title }}
                </button>
                <button class="btn btn-primary border-0 rounded-0"
                        (click)="nextSlide()">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>
            </div>

            <!-- Content -->
            <div class="row border mx-auto">
                <div class="col-md-5 p-4">
                    <img [src]="tabs[selectedIndex].content.img" class="w-100" alt="">
                </div>
                <div class="col-md-7 border-start p-4">
                    <h3 class="blue fw-semibold">{{ tabs[selectedIndex].title }}</h3>
                    <p>{{ tabs[selectedIndex].content.detail }}</p>
                    <ul>
                        <li *ngFor="let item of tabs[selectedIndex].content.list">
                            <p>{{ item }}</p>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="container-fluid bg-light">
    <div class="container  py-5">
        <div class="row align-items-center">
            <div class="col-md-5  p-5">
                <h2>
                    Our Process: Streamlined Approach for Cloud Excellence
                </h2>
                <img src="assets/img/landing-new/db-devops-serverless/business.png"
                     class="img-fluid border-radius-10"
                     alt="Image">
            </div>
            <div class="col-md-7 px-5">
                <div class="row  bg-white mb-3">
                    <div class="col-2 p-0">
                        <img class="img-fluid w-100 h-100" src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">
                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Evaluation and Strategy Development</h3>
                        <p>We start with an in-depth analysis of our client’s current infrastructure, business goals, and challenges with their current setup. Following the evaluation process, we craft a tailored strategy for cloud adoption and optimization.</p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-0">
                        <img  class="img-fluid w-100 h-100"  src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Implementation and Migration</h3>
                        <p> Once we have the complete strategy including the tools and techniques to be used, we initiate the designing and implementation process. We focus on minimizing downtime and maximizing efficiency to ensure smooth integration and migration.
                        </p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-0">
                        <img  class="img-fluid w-100 h-100"  src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Optimization and Monitoring</h3>
                        <p>After design, build, deployment, and implementation, we proceed to run the applications. Furthermore, we optimize your cloud infrastructure continuously to ensure high performance, and cost savings, while providing 24/7 monitoring to address any issues.</p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-0">
                        <img  class="img-fluid w-100 h-100"  src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Ongoing Support and Innovation</h3>
                        <p>This is not it, we provide a dedicated supporting team to ensure that your applications and systems remain up-to-date and meet with the ongoing advancements in public cloud computing to provide smooth workflow.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="container-fluid parallax3">
    <div class=" container py-5">
        <h2 class=" text-white  fw-bold justify-text"> Benefits of Choosing Volmint’s Public Cloud & Delivery Solutions</h2>
        <div class="row gy-3 pb-5 ">
            <ng-container  *ngFor="let item of benifits; let i = index">
                <div class="col-md-4  px-2"      [ngClass]="{
    'col-md-8': i === 0 || i === 3,
    'col-md-4': i === 1 || i === 2
  }">
                    <div class="bg-white border-brown-left h-100 pt-3 blue-shadow">
                        <!--                        <div class="d-flex align-items-center p-3  border-brown-left    fw-bold "><i [ngClass]="item.icon" class="fs-1 blue-color"></i></div>-->
                        <div class="px-3 pb-3   ">
                            <h3 class="fs-5 my-2 fw-bold blue-color">{{ item.header }}</h3>
                            <p class=" justify-text">{{
                                    item.text
                                }}</p>
                        </div>

                    </div>
                </div>
            </ng-container>
        </div>
    </div>

</div>

<div class="container-fluid">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="col-12">
                    <img src="assets/img/landing-new/mobile-development/faq.png" alt="Image" class="img-fluid w-50"/>
                    <p class="fs-1 fw-bold">Frequently Asked Questions</p>
                    <p class="text-muted">Have a question that is not answered? You can contact us at</p>
                    <p class="blue-color fw-bold">Email: <a href="mailto:support@volmint.com"
                                                            class="text-decoration-underline blue-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="brand-primary-bg border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span class="fs-6 w-100 fw-bold" style="color: #6292d7;">
                                    <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                          <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                          </div>
                                        </div>
                                        <div class="col-10 ps-3">
                                        What is public cloud computing?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Public Cloud Computing is like a storage and server that a third-party cloud services provider owns to manage all hardware, software, and other supporting infrastructure, and deliver applications on the internet.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span
                            class="fs-6 fw-bold w-100" style="color: #6292d7;">
                             <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                 <div class="col-10 ps-3">
                                    Can Volmint assist with database management services?
                                 </div>
                             </div>
                            </span>
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Yes, we have experts who help you identify workloads for the public cloud, rebuild applications, and initiate migration with minimal risk and cost. The service allows reduced risk mitigation, ensures complete operation and regulatory compliance of your cloud environment.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <span class="fs-6 fw-bold w-100" style="color: #6292d7;">
                                    <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-10 ps-3">
                                             What CDN platforms does Volmint support?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                We support platforms such as Akamai, Cloudflare, Amazon CloudFront, Limelight, and more to enhance your content delivery.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed w-100" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <span class="fs-6 fw-bold w-100" style="color: #6292d7;">
                                    <div class="row w-100  align-items-center">
                                        <div class="col-1 ">
                                            <div class="encircled-icon ">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-10 ps-3">
How does Volmint ensure security in the cloud?                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                We implement robust encryption, compliance monitoring, and real-time threat detection to safeguard your cloud environment.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                <span class="fs-6 fw-bold w-100" style="color: #6292d7;">
                                    <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                        <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-10 ps-3">
                                              Can Volmint help migrate existing systems to the cloud?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Yes, we specialize in smooth cloud migration, ensuring minimal disruption and optimal performance throughout the process.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid ums-bottom-bg ps-5 mt-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-md-10 col-12">
                <h1 class="text-white">Ready to Take Your Business Growth to the Next Level?</h1>
            </div>
            <div class="col-md-2 col-12">
                <button class="btn bg-white rounded-0 px-5 py-3 text-black fw-bold hover-effect"
                        (click)="goTo('/contact')">Contact Us
                </button>
            </div>
        </div>
    </div>
</div>
